(function () {
  var section = document.querySelector('.oddit-section-main-product');
  if (!section) return;

  // Shared refs + subscription/selling-plan state.
  var priceEl = section.querySelector('[data-product-price]');
  var savingsEl = section.querySelector('[data-product-savings]');
  var atcBtn = section.querySelector('[data-add-to-cart]');
  var atcLabelEl = atcBtn && atcBtn.querySelector('[data-button-label]');
  var subGroup = section.querySelector('[data-subscriptions]');
  var currentVariantId = atcBtn ? atcBtn.dataset.variantId : '';
  var selectedSub = subGroup ? subGroup.querySelector('.oddit-section-main-product__sub--selected') : null;

  // Per-variant pricing for each plan card, emitted server-side as JSON.
  var subPricing = {};
  var pricingEl = section.querySelector('[data-sub-pricing]');
  if (pricingEl) {
    try { subPricing = JSON.parse(pricingEl.textContent); } catch (e) { subPricing = {}; }
  }

  function variantOptions(vid) {
    var entry = subPricing[vid];
    return entry ? entry.options : null;
  }

  // ATC label mirrors the live price: "Add to cart • $XX" (or the sold-out text).
  function syncAtcLabel() {
    if (!atcBtn || !atcLabelEl) return;
    if (atcBtn.disabled) {
      atcLabelEl.textContent = atcBtn.dataset.atcSoldout;
      return;
    }
    var price = priceEl ? priceEl.textContent.trim() : '';
    atcLabelEl.textContent = price ? atcBtn.dataset.atcLabel + ' • ' + price : atcBtn.dataset.atcLabel;
  }

  // Header price + ATC selling plan reflect the selected subscription card for the current variant.
  // A quantity-upsell plan bills for several units per delivery, so the card also
  // carries the quantity the add-to-cart line has to use.
  function refreshHeaderFromSub() {
    if (atcBtn) atcBtn.dataset.planQty = '1';
    if (!selectedSub) return false;
    var opts = variantOptions(currentVariantId);
    var opt = opts && opts[selectedSub.dataset.planIndex];
    if (!opt) return false;
    if (priceEl) priceEl.textContent = opt.price;
    if (savingsEl) {
      savingsEl.textContent = opt.savings || '';
      savingsEl.hidden = !opt.savings;
    }
    if (atcBtn) {
      atcBtn.dataset.sellingPlan = selectedSub.dataset.sellingPlan || '';
      atcBtn.dataset.planQty = String(opt.qty || selectedSub.dataset.planQty || 1);
    }
    syncAtcLabel();
    return true;
  }

  // The selected card can be one the newly chosen variant doesn't sell — fall back
  // to the first card still on screen, which is the one-time card at worst.
  function ensureSelection() {
    if (!subGroup) return;
    if (selectedSub && !selectedSub.hidden) return;
    var next = subGroup.querySelector('[data-sub]:not([hidden])');
    subGroup.querySelectorAll('.oddit-section-main-product__sub--selected').forEach(function (s) {
      s.classList.remove('oddit-section-main-product__sub--selected');
    });
    selectedSub = next || null;
    if (selectedSub) selectedSub.classList.add('oddit-section-main-product__sub--selected');
  }

  // Each card re-prices when the variant changes, and any plan the variant has no
  // allocation for drops out of the list entirely — so a variant without a
  // subscription is left showing the one-time card on its own.
  function refreshCardPrices() {
    if (!subGroup) return;
    var opts = variantOptions(currentVariantId);
    if (!opts) return;
    subGroup.querySelectorAll('[data-sub]').forEach(function (card) {
      var opt = opts[card.dataset.planIndex];
      if (!opt) {
        card.hidden = true;
        return;
      }
      card.hidden = false;
      var newEl = card.querySelector('[data-sub-price-new]');
      var oldEl = card.querySelector('[data-sub-price-old]');
      var saveEl = card.querySelector('[data-sub-save]');
      var subtitleEl = card.querySelector('[data-sub-subtitle]');
      if (newEl) newEl.textContent = opt.price;
      if (oldEl) {
        oldEl.textContent = opt.hasOld ? opt.old : '';
        oldEl.hidden = !opt.hasOld;
      }
      if (saveEl && !saveEl.hasAttribute('data-sub-save-override') && typeof opt.pct === 'number') {
        saveEl.textContent = 'Save ' + opt.pct + '%';
        saveEl.hidden = opt.pct <= 0;
      }
      if (subtitleEl) {
        subtitleEl.textContent = opt.hasSubtitle ? opt.subtitle : '';
        subtitleEl.hidden = !opt.hasSubtitle;
      }
    });
    ensureSelection();
  }

  // Variant picker: highlight the choice and re-render price, savings, stock, and ATC.
  var variantGroup = section.querySelector('.oddit-section-main-product__variant-options');
  if (variantGroup) {
    var stockTextEl = section.querySelector('[data-stock-text]');
    var stockIconEl = section.querySelector('[data-stock-icon]');

    var applyVariant = function (btn) {
      var available = !btn.hasAttribute('data-variant-unavailable');
      var state = available ? (btn.hasAttribute('data-variant-low') ? 'low' : 'in') : 'out';

      if (priceEl && btn.dataset.variantPrice) priceEl.textContent = btn.dataset.variantPrice;

      if (savingsEl) {
        var savings = btn.dataset.variantSavings;
        savingsEl.textContent = savings || '';
        savingsEl.hidden = !savings;
      }

      if (stockTextEl) {
        stockTextEl.textContent =
          state === 'out' ? stockTextEl.dataset.stockOut
          : state === 'low' ? stockTextEl.dataset.stockLow
          : stockTextEl.dataset.stockIn;
      }
      if (stockIconEl) stockIconEl.dataset.state = state;

      if (atcBtn) {
        atcBtn.dataset.variantId = btn.dataset.variantId;
        atcBtn.disabled = !available;
        syncAtcLabel();
      }

      // Re-price subscription cards for the new variant, then let the selected plan drive the header.
      currentVariantId = btn.dataset.variantId;
      refreshCardPrices();
      refreshHeaderFromSub();
    };

    var showVariantMedia = function (btn, behavior) {
      var index = btn.dataset.variantMediaIndex;
      if (index === undefined || index === '') return;
      goToSlide(Number(index), behavior);
    };

    variantGroup.addEventListener('click', function (e) {
      var btn = e.target.closest('.oddit-section-main-product__variant');
      if (!btn || !variantGroup.contains(btn)) return;
      variantGroup.querySelectorAll('.oddit-section-main-product__variant').forEach(function (b) {
        b.classList.remove('oddit-section-main-product__variant--selected');
        b.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('oddit-section-main-product__variant--selected');
      btn.setAttribute('aria-checked', 'true');
      applyVariant(btn);
      showVariantMedia(btn);
    });

    var preselected = variantGroup.querySelector(
      '.oddit-section-main-product__variant--selected'
    );
    if (preselected) {
      requestAnimationFrame(function () {
        showVariantMedia(preselected, 'auto');
      });
    }
  }

  // Gallery carousel: thumbnails act as nav controls, native scroll-snap drives swipe.
  var track = section.querySelector('.oddit-section-main-product__gallery');
  var thumbs = Array.prototype.slice.call(
    section.querySelectorAll('.oddit-section-main-product__thumbnail')
  );

  var setActive = function (index) {
    thumbs.forEach(function (t, i) {
      t.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
  };

  // A click is the source of truth until its smooth scroll settles. Without this,
  // the animation's own scroll events walk the active ring across every slide it
  // passes through on the way, which reads as a flicker.
  var pending = -1;

  // Bring the clicked thumb toward the middle of the rail. Clamped by the browser
  // at both ends, so the first and last thumbs stay at the gutter rather than
  // leaving dead space.
  var strip = section.querySelector('.oddit-section-main-product__thumbnails');
  var centerThumb = function (thumb) {
    if (!strip || strip.scrollWidth <= strip.clientWidth) return; // desktop grid: nothing to scroll
    var t = thumb.getBoundingClientRect();
    var s = strip.getBoundingClientRect();
    var left = strip.scrollLeft + (t.left - s.left) - (s.width - t.width) / 2;
    strip.scrollTo({ left: left, behavior: 'smooth' });
  };

  function goToSlide(index, behavior) {
    if (!track || !(index >= 0) || !track.clientWidth) return;
    var slide = section.querySelector(
      '.oddit-section-main-product__slide[data-slide-index="' + index + '"]'
    );
    if (!slide) return;
    pending = index;
    track.scrollTo({ left: index * track.clientWidth, behavior: behavior || 'smooth' });
    setActive(index);
    if (thumbs[index]) centerThumb(thumbs[index]);
  }

  // ---- Click-to-zoom lightbox (shared by the main image and the thumbnails) ----
  // Gallery slides open full-screen so the infographic slides (What's Included,
  // How to Take, Supplement Facts) are readable. Every gallery item is zoomable:
  // the main image and each thumbnail open their own full-size image.
  // Once open it slides through the whole gallery — arrows, arrow keys or swipe.
  var lightbox = null;
  var lightboxIndex = 0;

  function galleryImgs() {
    return Array.prototype.slice.call(
      section.querySelectorAll('.oddit-section-main-product__slide-img')
    );
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Sharpest srcset candidate for a slide image.
  function bestSrc(img) {
    var src = img.currentSrc || img.src;
    if (img.srcset) {
      var bestW = 0;
      img.srcset.split(',').forEach(function (entry) {
        var parts = entry.trim().split(/\s+/);
        var w = parseInt((parts[1] || '').replace('w', ''), 10) || 0;
        if (w > bestW) { bestW = w; src = parts[0]; }
      });
    }
    return src;
  }

  function renderLightbox() {
    var imgs = galleryImgs();
    var img = imgs[lightboxIndex];
    if (!lightbox || !img) return;
    var lbImg = lightbox.querySelector('.oddit-section-main-product__lightbox-img');
    lbImg.src = bestSrc(img);
    lbImg.alt = img.alt || '';
    lightbox.querySelectorAll('[data-lightbox-nav]').forEach(function (btn) {
      btn.hidden = imgs.length < 2;
    });
  }

  function stepLightbox(delta) {
    var imgs = galleryImgs();
    if (imgs.length < 2) return;
    lightboxIndex = (lightboxIndex + delta + imgs.length) % imgs.length;
    renderLightbox();
  }

  function buildLightbox() {
    lightbox = document.createElement('div');
    lightbox.className = 'oddit-section-main-product__lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-label', 'Image zoom');
    lightbox.innerHTML =
      '<button type="button" class="oddit-section-main-product__lightbox-close" aria-label="Close image zoom">&#215;</button>' +
      '<button type="button" class="oddit-section-main-product__lightbox-nav oddit-section-main-product__lightbox-nav--prev" data-lightbox-nav="-1" aria-label="Previous image">&#8249;</button>' +
      '<img class="oddit-section-main-product__lightbox-img" alt="">' +
      '<button type="button" class="oddit-section-main-product__lightbox-nav oddit-section-main-product__lightbox-nav--next" data-lightbox-nav="1" aria-label="Next image">&#8250;</button>';

    // Backdrop still closes, but the image and its controls must not.
    lightbox.addEventListener('click', function (e) {
      var nav = e.target.closest('[data-lightbox-nav]');
      if (nav) {
        stepLightbox(Number(nav.getAttribute('data-lightbox-nav')));
        return;
      }
      if (e.target.closest('.oddit-section-main-product__lightbox-img')) return;
      closeLightbox();
    });

    document.addEventListener('keydown', function (e) {
      if (!lightbox || !lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') stepLightbox(-1);
      else if (e.key === 'ArrowRight') stepLightbox(1);
    });

    var touchX = null;
    lightbox.addEventListener('touchstart', function (e) {
      touchX = e.changedTouches[0].clientX;
    }, { passive: true });
    lightbox.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) > 40) stepLightbox(dx < 0 ? 1 : -1);
    }, { passive: true });

    document.body.appendChild(lightbox);
  }

  function openLightboxAt(index) {
    if (index < 0) return;
    if (!lightbox) buildLightbox();
    lightboxIndex = index;
    renderLightbox();
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  // Open the zoom at the position of the clicked slide image.
  function zoomFromImg(img) {
    if (!img) return;
    var index = galleryImgs().indexOf(img);
    openLightboxAt(index === -1 ? 0 : index);
  }
  // The gallery slide image that matches a thumbnail index (data-slide-index).
  function slideImgForIndex(index) {
    var slide = section.querySelector(
      '.oddit-section-main-product__slide[data-slide-index="' + index + '"]'
    );
    return slide ? slide.querySelector('.oddit-section-main-product__slide-img') : null;
  }

  if (track && thumbs.length) {
    // Desktop lays every image out as a large grid tile, so a click should zoom
    // that specific item (ZW-32) rather than only nudging the scrolled-away main
    // image. Mobile keeps the thumbnails as nav controls for the swipe carousel.
    var zoomOnThumbClick = window.matchMedia('(min-width: 990px)');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = Number(thumb.dataset.thumbnailIndex) || 0;
        if (zoomOnThumbClick.matches) {
          zoomFromImg(slideImgForIndex(index));
          return;
        }
        // scroll the track itself, never scrollIntoView — that would also scroll the page
        goToSlide(index);
      });
    });

    // A real user gesture always wins over an in-flight programmatic scroll
    ['pointerdown', 'wheel', 'touchstart'].forEach(function (evt) {
      track.addEventListener(
        evt,
        function () {
          pending = -1;
        },
        { passive: true }
      );
    });

    // Swiping the gallery must sync the thumbnails back
    var raf = 0;
    track.addEventListener(
      'scroll',
      function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          if (!track.clientWidth) return;
          var index = Math.round(track.scrollLeft / track.clientWidth);
          if (pending !== -1) {
            // still animating toward the clicked slide — ignore the frames in between
            if (index === pending) pending = -1;
            return;
          }
          setActive(index);
          // Keep the active thumb in view when the user swipes the gallery —
          // without this the ring can sit on a thumbnail scrolled off-strip.
          if (thumbs[index]) centerThumb(thumbs[index]);
        });
      },
      { passive: true }
    );
  }

  if (track) {
    track.addEventListener('click', function (e) {
      zoomFromImg(e.target.closest('.oddit-section-main-product__slide-img'));
    });
  }

  // Subscription option: select a plan → re-price header + set the ATC selling plan.
  if (subGroup) {
    subGroup.addEventListener('click', function (e) {
      var card = e.target.closest('[data-sub]');
      if (!card || !subGroup.contains(card)) return;
      subGroup.querySelectorAll('.oddit-section-main-product__sub--selected').forEach(function (s) {
        s.classList.remove('oddit-section-main-product__sub--selected');
      });
      card.classList.add('oddit-section-main-product__sub--selected');
      selectedSub = card;
      refreshHeaderFromSub();
    });

    // Sync card prices + header + ATC plan to the default-selected card on load.
    refreshCardPrices();
    refreshHeaderFromSub();
  }

  // Add to cart via the shared cart drawer, carrying the selected selling plan.
  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      if (atcBtn.disabled) return;
      var api = window.OdditCartDrawer;
      if (!api || !api.addToCart) return;
      var plan = atcBtn.dataset.sellingPlan;
      var qty = Number(atcBtn.dataset.planQty) || 1;
      atcBtn.disabled = true;
      Promise.resolve(api.addToCart(atcBtn.dataset.variantId, qty, {}, plan ? Number(plan) : null))
        .catch(function () {})
        .then(function () { atcBtn.disabled = false; });
    });
  }
})();
